import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerReport = async (data: CustomerReportReqT) => {
  const {
    pageParam,
    mobile,
    customer_types,
    friendships,
    cities,
    popular_groups,
    customer_groups,
    colleague_companies,
    creators,
    pagination = 25,
    noAddress,
  } = data;

  let qs = `?page=${pageParam ?? 1}&pagination=${pagination}`;
  qs += mobile ? "&phone=" + mobile : "";
  qs += customer_types ? "&customer_types=" + customer_types : "";
  qs += popular_groups ? "&popular_groups=" + popular_groups : "";
  qs += noAddress ? "&noAddress=" + noAddress : "";
  qs += cities?.length > 0 ? "&cities[]=" + cities : "";
  qs += creators?.length > 0 ? "&creators[]=" + creators : "";
  qs += friendships?.length > 0 ? "&friendships[]=" + friendships : "";
  qs +=
    customer_groups?.length > 0 ? "&customer_groups[]=" + customer_groups : "";
  qs +=
    colleague_companies?.length > 0
      ? "&colleague_companies[]=" + colleague_companies
      : "";

  return axios.get(Routes.CUSTOMER_REPORT + qs);
};

export const useCustomerReport = (params: CustomerReportReqT) => {
  const {
    mobile,
    customer_types,
    friendships,
    cities,
    popular_groups,
    customer_groups,
    colleague_companies,
    creators,
    disable,
    noAddress,
  } = params;
  return useInfiniteQuery({
    queryKey: [
      Keys.CUSTOMER_REPORT_QRY,
      mobile,
      customer_types,
      friendships,
      cities,
      popular_groups,
      customer_groups,
      colleague_companies,
      creators,
      noAddress,
    ],
    queryFn: ({ pageParam = 1 }) => customerReport({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
    enabled: !disable,
  });
};
